import { render, staticRenderFns } from "./message-table.vue?vue&type=template&id=cabf0448&scoped=true&"
import script from "./message-table.vue?vue&type=script&lang=js&"
export * from "./message-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabf0448",
  null
  
)

export default component.exports